import styled from 'styled-components';
import { Fonts, Palette } from '../../components/utils';

/** Centered secondary empty / error copy used across chat panels. */
export const ChatEmptyText = styled.p`
  margin: 0;
  color: ${Palette.CONTENT_TERTIARY};
  font-family: ${Fonts.OPEN_SANS_FONT};
  font-size: 14px;
  font-weight: 400;
  text-align: center;
`;

/** Wrapper for the load-more / load-older spinner. */
export const ChatOlderLoadingWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 8px 0 16px;
  flex-shrink: 0;
`;
